import { Box, Typography } from '@mui/material';
import { useGame } from 'contexts/Game/Game';
import * as setup from 'setup';
import { Slider } from './PredictionSlider.styles';

export default function PredictionSlider() {

    const game = useGame();

    function handleChange(value: number) {
        game.updatePredictions({
            initialMonthly: value,
        });
    }

    return (
        <Box
            sx={{
                marginX: 'auto',
                width: 340
            }}>
            <Typography align="center" variant="montserrat636" sx={{
                marginBottom: 0
            }}>
                ${game.predictions.initialMonthly.toLocaleString()}
            </Typography>
            <Typography
                align="center"
                variant="montserrat618"
                sx={{
                    marginBottom: 4
                }}>
                (average ${Math.trunc(game.predictions.initial).toLocaleString()}/day)
            </Typography>
            <Slider
                max={setup.game.prediction.max}
                min={setup.game.prediction.min}
                step={100}
                value={game.predictions.initialMonthly}
                onChange={(value: any) => handleChange(value)}
            />
        </Box>
    );

}